import React from "react"

const NavItem = ({ children, className}) => {
  className = `${className ? ` ${className} ` : ''}`
  
  return <li className={`nav-item${className}`}>{children}</li>
}
export default NavItem
